(ns kyber.kyber-db.curriculum)

(def model
  {:ident-key
   :curriculum/uuid

   :refs
   {:curriculum/activities {:model :activity
                            :cardinality :many}
    :curriculum/intro-activity {:model :activity
                                :cardinality :one}
    :curriculum/learners {:model :curriculum-learner
                          :cardinality :many}
    :curriculum/resources {:model :resource
                           :cardinality :many}}

   :schema
   #:curriculum
   {:uuid
    {:doc "UUID of a curriculum"}

    :activity-sort-order
    {:doc "The order activities should be displayed"}

    :clp-banner
    {:doc "Banner image on the CLP page"}

    :clp-enabled
    {:doc "Is the CLP page enabled"}

    :data-type
    {:doc "We should not be using this locally... keeping for now"}

    :description
    {:doc "Curriculum description"}

    :enforce-activity-order
    {:doc "Do leaners need to take activities by their sort order?"}

    :leaderboard-enabled
    {:doc "Depricated..."}

    :max-number-of-activities
    {:doc "Max number of activities that are allowed"}

    :name
    {:doc "Name of the curriculum"}

    :sign-in-display-name
    {:doc ""}}})
